
import Bugsnag from '@bugsnag/js';
import GwButton from '~/patterns/atoms/button/button.vue';
import GwIcon from '~/patterns/atoms/icon/icon.vue';
import GwInput from '~/patterns/atoms/input/input';

export default {
    components: {
        GwInput,
        GwButton,
        GwIcon,
    },
    props: {
        editionId: {
            type: String,
            required: true,
        },
        currency: {
            type: String,
            default: '',
            required: false,
        },
    },
    data() {
        return {
            isAddingCoupon: false,
            couponCode: null,
            invalidCoupon: false
        };
    },
    watch: {
        couponCode() {
            this.clearFeedback();
        }
    },
    methods: {
        toggleCouponCode() {
            this.isAddingCoupon = !this.isAddingCoupon;
            this.invalidCoupon = false;
        },
        clearFeedback() {
            this.invalidCoupon = false;
        },
        async checkCouponCode() {
            await this.$axios.post(this.$config.apiUrl + '/api/prices/discount', {
                currency: this.currency,
                site: this.$config.appMultisiteHandle,
                editionId: this.editionId,
                couponCode: this.couponCode
            })
                .then((response) => {
                    this.invalidCoupon = false;
                    if (!response.data.isValid) {
                        this.invalidCoupon = true;

                        return;
                    }

                    this.$emit('addedCoupon', this.couponCode);
                })
                .catch((error) => {
                    this.invalidCoupon = true;

                    console.error(error); // eslint-disable-line no-console

                    Bugsnag.notify(error, (event) => {
                        event.addMetadata('coupon', {
                            currency: this.currency,
                            site: this.$config.appMultisiteHandle,
                            editionId: this.editionId,
                            couponCode: this.couponCode
                        });
                    });
                });
        },
    },
};
